import { PRODUCTS, RECO, RECO_SEARCH, RECO_TYPE } from '@/routes/product'

import PassThroughView from '@/views/general/PassThroughView'

const RecoSearchView = () => import(/* webpackChunkName: "reco" */'@/views/reco/RecoSearchView')
const RecoRecommendationView = () => import(/* webpackChunkName: "reco" */'@/views/reco/RecoRecommendationView')

export default [
  {
    path: '/products',
    component: PassThroughView,
    meta: {
      titleKey: 'reco.title',
      root: PRODUCTS,
      mainRoutes: [ RECO ]
    },
    children: [
      {
        path: '',
        component: PassThroughView,
        name: RECO,
        meta: {
          titleKey: 'reco.title'
        },
        props: () => {
          return {
            routeName: RECO,
            defaultRouteName: RECO_SEARCH,
            defaultRouteParams: { type: 'search' }
          }
        },
        children: [
          {
            path: ':type',
            component: RecoSearchView,
            name: RECO_SEARCH,
            meta: {
              titleKey: 'reco.title'
            },
            props: true,
            children: [
              {
                path: ':typeId/:searchId',
                component: RecoRecommendationView,
                name: RECO_TYPE,
                props: true
              }
            ]
          }
        ]
      }
    ]
  }
]
